import { Component } from "react";
import PropTypes from "prop-types";
import wrap from "LIB/domHelpers";

export default class Dismissible extends Component {
  static propTypes = {
    show: PropTypes.bool
  };

  static defaultProps = {
    show: false
  };

  state = {
    visible: this.props.show
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.onClickAway);
  }

  onClickAway = e => {
    if (!wrap(this.content).contains(e.target)) {
      this.close();
    }
  };

  toggle = e => {
    e.stopPropagation();
    this.setState(state => ({ visible: this.listen(!state.visible) }));
  };

  open = () => this.setState({ visible: this.listen(true) });
  close = () => this.setState({ visible: this.listen(false) });

  listen(on = true) {
    if (on) {
      document.addEventListener("click", this.onClickAway);
    } else {
      document.removeEventListener("click", this.onClickAway);
    }

    return on;
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/Dismissible/Dismissible.jsx